module.exports = __webpack_public_path__ + "static/img/11.8a23119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sliders/3/11.jpg
// module id = 8z8U
// module chunks = 0